import TitleBox from "../components/TitleBox/TitleBox"
import PageHeader from "../components/PageHeader/PageHeader"
import "../components/PageHeader/PageHeader.scss"

export default function PanelLayout({
  title,
  subtitle,
  children,
  actions,
  noBottom,
  style,
  spacing = true,
  enableFilter = false,
  filterContent,
  exportable = false,
  exportContent,
  onFilter,
  onClear,
}) {
  const layoutClass = `panel-layout${noBottom ? " mb-0" : ""}`
  const contentClass = spacing ? "sips" : ""

  return (
    <div className="panel-layout-root">
      {title && (
        <TitleBox
          title={title}
          onFilter={onFilter}
          onClear={onClear}
          enableFilter={enableFilter}
          filtercontent={filterContent}
          exportable={exportable}
          exportOptions={exportContent}
        >
          {actions}
        </TitleBox>
      )}
      <div className={layoutClass} style={style}>
        <div className={contentClass}>
          {subtitle ? <PageHeader subtitle={subtitle} /> : null}
          {children}
        </div>
      </div>
    </div>
  )
}
